<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="6" class="content_category mb-3 rounded-lg">
          <v-col cols="12">
            <v-text-field
              filled
              background-color="#EDF2F7"
              item-text="text"
              v-model="name_package"
              item-value="value"
              label="Tên gói khuyến mại"
              placeholder="Nhập tên"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-menu
                  class="float-left"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  background-color="#EDF2F7"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled
                      class="mr-3 float-left"
                      background-color="#EDF2F7"
                      label="Thời gian bắt đầu"
                      v-model="start_date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  class="float-left"
                  background-color="#EDF2F7"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  v-model="menu2"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled
                      background-color="#EDF2F7"
                      class="mr-3 float-left"
                      v-model="end_date"
                      label="Thời gian kết thúc"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-col cols="12" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-row>
                  <h3 class="mt-2">Quà tặng</h3>
                  <v-btn class="ml-5 mb-5" color="primary" @click="addGifts()">
                    Thêm
                  </v-btn>
                </v-row>
                <v-col>
                  <v-divider></v-divider>
                  <div
                    class="content_property mt-5 rounded-lg"
                    v-for="(item, index) in gifts"
                    :key="index"
                  >
                    <v-col>
                      <v-row>
                        <v-col cols="9">
                          <v-autocomplete
                            :items="promotions"
                            item-text="name"
                            item-value="id"
                            v-model="item.id"
                            background-color="#EDF2F7"
                            filled
                            label="Quà tặng"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <v-btn
                            class="ml-5 mb-1 mt-1"
                            color="primary"
                            @click="clearGifts(index)"
                          >
                            Xóa
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-col>
          <v-col cols="12" class="text-center mb-2">
            <v-btn width="130" color="primary" @click="save"> Lưu </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GET_LIST_PROMOTIONS, 
  GET_DETAIL_PACKAGES,
  UPDATE_PACKAGES
} from "@/store/modules/promotion_gift";
export default {
  data() {
    return {
      name_package: null,
      start_date: null,
      end_date: null,
      menu1: false,
      menu2: false,
      gifts: [],
      page: "Quà tặng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Khuyến mại/Quà tặng",
          disabled: true,
        },
        {
          text: "Quà tặng",
          disabled: true,
        },
        {
          text: "Thêm gói quà tặng",
          disabled: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      promotions: "promotions",
      packageDetail: "packageDetail",
    }),
  },

  watch: {
    packageDetail(val) {
        this.name_package =  val.name;
        this.start_date = val.start_date;
        this.end_date = val.end_date;
        this.gifts = val.promotions
    },
  },

  async created() {
    this.url = process.env.VUE_APP_API_URL;
    await this.$store.dispatch(GET_LIST_PROMOTIONS);
    await this.$store.dispatch(`${GET_DETAIL_PACKAGES}`, this.$route.params.id);
  },
  methods: {
    formatDate(input) {
      let datePart = input.match(/\d+/g),
        year = datePart[0], // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + "/" + month + "/" + year;
    },
    save() {
      let formStartDate = "";
      let formEndDate = "";
      if (this.start_date) {
        formStartDate = this.formatDate(this.start_date.replace(/-/gi, "/"));
      }
      if (this.end_date) {
        formEndDate = this.formatDate(this.end_date.replace(/-/gi, "/"));
      }
      let package_form = {
        id : this.packageDetail.id,
        name: this.name_package,
        start_date: formStartDate,
        end_date: formEndDate,
        promotions: JSON.stringify(this.gifts),
      };
      this.$store
        .dispatch(`${UPDATE_PACKAGES}`, package_form)
        .then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.push("/manage_promotion_gift/Manage_gift");
          } else {
            alert(data.data.errors);
          }
        });
    },

    addGifts() {
      this.gifts.push({
        id: null,
      });
    },
    clearGifts(i) {
      this.gifts.splice(i, 1);
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
  .checkbox {
    height: 20px !important;
    width: 20px !important;
  }
}
</style>
